import { runClientComponent } from '../../_common/client/client-component-runner';
import { CustomerReviewStarFilterComponent } from './customer-review-star-filter.component';

runClientComponent({ CustomerReviewStarFilterComponent });
